import React, { useState, useEffect } from 'react';
import { motion } from 'motion/react';
import CyberLoader from '../common/CyberLoader';
import ParticleBackground from '../common/ParticleBackground';
import './Dashboard.css'; // Reuse dashboard styles

export default function Leaderboard({ onBack }) {
  const [leaderboard, setLeaderboard] = useState(null);
  const [loading, setLoading] = useState(true);
  
  // Default to 28
  const [activeTab, setActiveTab] = useState('28');

  useEffect(() => {
    const fetchLeaderboard = async () => {
      const baseUrl = process.env.REACT_APP_BACKEND_URL || '';
      const token = localStorage.getItem('vault_jwt');
      try {
        const resp = await fetch(`${baseUrl}/api/leaderboard`, {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        if (resp.ok) {
          setLeaderboard(await resp.json());
        }
      } catch (e) {}
      setLoading(false);
    };
    fetchLeaderboard();
  }, []);

  const renderHistory = (hist) => {
    // Pad to exactly 5 games (from the left if recent is right, or right if recent is left)
    // The query orders by rn DESC (which is end_time ASC for the last 5 matches, so oldest of the 5 is first, newest is last).
    // So 'hist' looks like "WLW". We pad Start to push the games to the right: "--WLW"
    const padded = (hist || '').padStart(5, '-').substring(0, 5);
    return (
      <div style={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
        {padded.split('').map((char, i) => {
          let color = '#94a3b8'; // gray
          if (char === 'W') color = '#4ade80'; // green
          if (char === 'L') color = '#f87171'; // red
          return (
            <React.Fragment key={i}>
              <span style={{ color, fontWeight: '900' }}>{char}</span>
              {i < 4 && <span style={{ color: 'rgba(255,255,255,0.2)' }}>/</span>}
            </React.Fragment>
          );
        })}
      </div>
    );
  };

  const renderTable = (mode) => {
    const data = leaderboard?.[mode] || [];
    if (data.length === 0) {
      return (
        <div style={{ padding: '24px' }}>
          <h2 style={{ textAlign: 'center', color: 'var(--text-muted)' }}>No data available yet for this mode.</h2>
        </div>
      );
    }

    return (
      <div style={{ overflowX: 'auto', padding: '24px' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left' }}>
          <thead>
            <tr style={{ borderBottom: '2px solid rgba(251,191,36,0.3)', color: '#fbbf24' }}>
              <th style={{ padding: '12px' }}>Rank</th>
              <th style={{ padding: '12px' }}>Player</th>
              <th style={{ padding: '12px' }}>Wins</th>
              <th style={{ padding: '12px' }}>Losses</th>
              <th style={{ padding: '12px' }}>Played</th>
              <th style={{ padding: '12px' }}>Recent Form</th>
              <th style={{ padding: '12px', whiteSpace: 'nowrap' }}>Avg Hand Pts (L5)</th>
              <th style={{ padding: '12px', whiteSpace: 'nowrap' }}>Expected Win % (L5)</th>
              <th style={{ padding: '12px' }}>Global Avg Pts</th>
              {(mode === '28' || mode === '56') && (
                <th style={{ padding: '12px' }}>Best Point Gap</th>
              )}
            </tr>
          </thead>
          <tbody>
            {data.map((entry, index) => (
              <tr key={entry.username} style={{ borderBottom: '1px solid rgba(255,255,255,0.1)' }}>
                <td style={{ padding: '12px', fontWeight: 'bold' }}>#{index + 1}</td>
                <td style={{ padding: '12px' }}>{entry.username}</td>
                <td style={{ padding: '12px', color: '#4ade80' }}>{entry.matches_won}</td>
                <td style={{ padding: '12px', color: '#f87171' }}>{entry.matches_lost}</td>
                <td style={{ padding: '12px' }}>{entry.matches_played}</td>
                <td style={{ padding: '12px' }}>{renderHistory(entry.recent_history)}</td>
                <td style={{ padding: '12px', color: '#60a5fa', whiteSpace: 'nowrap' }}>{entry.recent_avg_pts || '0.0'}</td>
                <td style={{ padding: '12px', color: '#fcd34d', whiteSpace: 'nowrap' }}>{entry.recent_avg_win_pct || '0%'}</td>
                <td style={{ padding: '12px', color: '#818cf8' }}>{entry.global_avg_pts?.toFixed(1) || '0.0'}</td>
                {(mode === '28' || mode === '56') && (
                  <td style={{ padding: '12px', color: '#a7f3d0' }}>{entry.best_win_gap}</td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  return (
    <div className="dashboard-screen">
      <ParticleBackground />
      <div className="dashboard-header">
        <button className="btn btn-primary back-btn" onClick={onBack} style={{ width: 'auto' }}>
           ← Back to Lobby
        </button>
      </div>

      <motion.div 
        className="dashboard-content"
        style={{ maxWidth: '1200px', width: '95%' }}
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
      >
        <div className="dashboard-card stats-card">
          <h2>Global Leaderboard</h2>

        {loading ? (
          <div style={{ display: 'flex', justifyContent: 'center', marginTop: '100px' }}>
            <CyberLoader text="Loading Rankings..." />
          </div>
        ) : (
          <>
            <div className="dash-tabs-container" style={{ display: 'flex', justifyContent: 'center' }}>
              <div className="dash-tabs">
                <button 
                  className={`dash-tab ${activeTab === '28' ? 'active' : ''}`}
                  onClick={() => setActiveTab('28')}
                >
                28
              </button>
              <button 
                className={`dash-tab ${activeTab === '56' ? 'active' : ''}`}
                onClick={() => setActiveTab('56')}
              >
                56
              </button>
              <button 
                className={`dash-tab ${activeTab === 'donkey' ? 'active' : ''}`}
                onClick={() => setActiveTab('donkey')}
              >
                Donkey
                </button>
              </div>
            </div>

            <div className="stats-container" style={{ marginTop: '24px' }}>
              {renderTable(activeTab)}
            </div>
          </>
        )}
        </div>
      </motion.div>
    </div>
  );
}
